module.exports = __webpack_public_path__ + "static/media/SKY BLUE PNR.7d7f0bc0.svg";